import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { ERROR_TEXT, INTER, NAVY, POPPINS } from '../style/verbaScholaStyles';

/** Confirm a consequential authoring deletion before calling the existing save workflow. */
export default function VerbaScholaConfirmDeleteButton({ label, onConfirm, disabled = false, sx = {}, description }: {
    label: string;
    onConfirm: () => Promise<void>;
    disabled?: boolean;
    sx?: Record<string, unknown>;
    /** What confirming does, when it is not a saved deletion (a review draft's removal resolves at once). */
    description?: string;
}) {
    const [open, setOpen] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);

    const confirm = () => {
        setDeleting(true);
        onConfirm()
            .then(() => setOpen(false))
            .catch(() => undefined)
            .finally(() => setDeleting(false));
    };

    return <>
        <Button startIcon={<DeleteOutlineRoundedIcon />} disabled={disabled} onClick={() => setOpen(true)} sx={{ fontFamily: INTER, fontWeight: 700, color: ERROR_TEXT, textTransform: 'none', ...sx }}>{label}</Button>
        <Dialog open={open} onClose={deleting ? undefined : () => setOpen(false)} aria-label={`${label} confirmation`} PaperProps={{ sx: { borderRadius: '20px' } }}>
            <DialogTitle sx={{ fontFamily: POPPINS, fontWeight: 600, color: NAVY }}>{label}?</DialogTitle>
            <DialogContent><DialogContentText>{description ?? 'This removes the saved item from the lesson. This action cannot be undone.'}</DialogContentText></DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button disabled={deleting} onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant="contained" disabled={deleting} onClick={confirm} sx={{ backgroundColor: ERROR_TEXT, color: '#fff', '&:hover': { backgroundColor: ERROR_TEXT, filter: 'brightness(0.9)' } }}>{deleting && !description ? 'Deleting…' : label}</Button>
            </DialogActions>
        </Dialog>
    </>;
}
